import { z } from 'zod';
import { UserRole, WorkspaceStatus, ProjectStatus, TemplateCategory, TemplateApproach } from '../types/index.js';
export const CreateUserSchema = z.object({
    email: z.string().email('Invalid email format'),
    name: z.string().min(2, 'Name must be at least 2 characters'),
    role: z.nativeEnum(UserRole),
});
export const UpdateUserSchema = CreateUserSchema.partial();
export const LoginSchema = z.object({
    email: z.string().email('Invalid email format'),
    password: z.string().min(8, 'Password must be at least 8 characters'),
});
export const CreateWorkspaceSchema = z.object({
    name: z.string().min(3, 'Workspace name must be at least 3 characters'),
    description: z.string().optional(),
    status: z.nativeEnum(WorkspaceStatus).default(WorkspaceStatus.DRAFT),
});
export const UpdateWorkspaceSchema = CreateWorkspaceSchema.partial();
export const CreateProjectSchema = z.object({
    name: z.string().min(3, 'Project name must be at least 3 characters'),
    description: z.string().optional(),
    workspaceId: z.string().uuid('Invalid workspace ID'),
    templateId: z.string().uuid('Invalid template ID').optional(),
    sourceLanguage: z.string().min(1, 'Source language is required'),
    targetLanguage: z.string().min(1, 'Target language is required'),
    status: z.nativeEnum(ProjectStatus).default(ProjectStatus.PLANNING),
});
export const UpdateProjectSchema = CreateProjectSchema.partial();
export const CreateTemplateSchema = z.object({
    name: z.string().min(3, 'Template name must be at least 3 characters'),
    description: z.string().min(10, 'Description must be at least 10 characters'),
    category: z.nativeEnum(TemplateCategory),
    approach: z.nativeEnum(TemplateApproach),
    sourceLanguages: z.array(z.string()).min(1, 'At least one source language required'),
    targetLanguages: z.array(z.string()).min(1, 'At least one target language required'),
    isActive: z.boolean().default(true),
});
export const UpdateTemplateSchema = CreateTemplateSchema.partial();
export const PaginationSchema = z.object({
    page: z.coerce.number().min(1).default(1),
    limit: z.coerce.number().min(1).max(100).default(10),
});
export const SearchSchema = z.object({
    q: z.string().optional(),
    sortBy: z.string().optional(),
    sortOrder: z.enum(['asc', 'desc']).default('desc'),
});
export * from './code-analysis-schemas.js';
export * from './nlqDependencyQuery.schema.js';
export * from './indexRunProgress.schema.js';
//# sourceMappingURL=index.js.map